import { Dropdown } from "react-bootstrap";
import { sanitizeInput } from "../common/security-utils";

import tripIcon from "../../assets/svg/trip-list.svg";
import truckIcon from "../../assets/svg/truck_ic.svg";
import moreIcon from "../../assets/svg/more_ic.svg";

const TripsGridView = ({
    isLoading,
    tripsList,
    checkPermission,
    navigate,
    setDeleteId,
    getMilestoneDetails,
    setAllocationTripId,
    setShowDriverAllocationModal,
}) => {
    if (isLoading) {
        return (
            <>
                {Array.from({ length: 5 }).map((_, index) => (
                    <div key={`skeleton-grid-${index}`} className="bg-white rounded-4 d-flex flex-wrap align-items-center justify-content-between business-card w-100 p-3 mb-3">
                        {/* Avatar and Trip ID Section */}
                        <div className="col-3 d-flex" style={{ borderRight: "1px solid #EBEBEB" }}>
                            <div className="skeleton skeleton-avatar" />
                            <div className="d-flex flex-column justify-content-center align-items-start gap-2 ps-3" style={{ flex: 1 }}>
                                <div className="skeleton skeleton-text" style={{ width: "120px", height: "16px" }} />
                                <div className="skeleton skeleton-text-sm" style={{ width: "150px", height: "12px" }} />
                            </div>
                        </div>

                        {/* Dates Section */}
                        <div className="col-3 ps-3 d-flex flex-column align-items-start justify-content-start pe-1" style={{ borderRight: "1px solid #EBEBEB" }}>
                            <div className="d-flex flex-column gap-2 w-100">
                                <div className="skeleton skeleton-text" style={{ width: "100%", height: "14px" }} />
                                <div className="skeleton skeleton-text" style={{ width: "100%", height: "14px" }} />
                            </div>
                        </div>

                        {/* Address Section */}
                        <div className="col-4 ps-3 d-flex flex-column align-items-start justify-content-start pe-1" style={{ borderRight: "1px solid #EBEBEB" }}>
                            <div className="d-flex flex-column gap-2 w-100">
                                <div className="skeleton skeleton-text" style={{ width: "100%", height: "14px" }} />
                                <div className="skeleton skeleton-text" style={{ width: "100%", height: "14px" }} />
                            </div>
                        </div>

                        {/* Status and Actions Section */}
                        <div className="col-2 d-flex flex-row align-items-end justify-content-end gap-2 ps-3">
                            <div className="skeleton skeleton-button" style={{ width: "80px", height: "32px", borderRadius: "8px" }} />
                            <div className="skeleton" style={{ width: "36px", height: "36px", borderRadius: "50%" }} />
                        </div>
                    </div>
                ))}
            </>
        );
    }

    return (
        <>
            {tripsList.map((stop, index) => (
                <div
                    key={index}
                    className="trip-grid-card bg-white rounded-4 d-flex flex-wrap align-items-center justify-content-between business-card w-100 p-3 mb-3"
                    onClick={() => {
                        if (checkPermission("view_permission")) {
                            navigate("/trips/view", {
                                state: { id: stop.id },
                            });
                        }
                    }}
                >
                    <div className="trip-grid-col-border col-3 d-flex">
                        <div className="trip-grid-profile-wrapper profile-wrapper">
                            <img key={index} src={tripIcon} alt="trip" className="profile-img" />
                        </div>
                        <div className="d-flex flex-column justify-content-center align-items-start gap-1 ps-3">
                            <div className="textFontColor fs-16 fw-600 ">{sanitizeInput(stop.trip_id ?? "-")}</div>
                            {stop.license_plate !== null && stop.license_plate !== "" && (
                                <div className="d-flex gap-2  align-items-center">
                                    <img src={truckIcon} alt="license_plate" /> <span className="text-gray fs-12 fw-500">{sanitizeInput(stop.license_plate ?? "")}</span>
                                    {" - "}
                                    <span className="text-gray fs-12 fw-500">{sanitizeInput(stop.vehicle_name ?? "")}</span>
                                </div>
                            )}
                        </div>
                    </div>

                    <div className="trip-grid-col-border col-3 ps-3 d-flex flex-column align-items-start justify-content-start pe-1">
                        <div className="d-flex flex-column flex-grow-1 align-items-start ">
                            <div className="fs-12 fw-600 cardTextGrey">
                                STARTS ON : <span className="fs-14 fw-400 textcolor">{sanitizeInput(stop.trip_startdate ?? "")}</span>
                            </div>
                            <div className="fs-12 fw-600 cardTextGrey mt-1">
                                ENDS ON : <span className="fs-14 fw-400 textcolor">{sanitizeInput(stop.trip_enddate ?? "")}</span>
                            </div>
                        </div>
                    </div>

                    <div className="trip-grid-col-border col-4 ps-3 d-flex flex-column align-items-start justify-content-start pe-1">
                        <div className="d-flex flex-column flex-grow-1 align-items-start ">
                            <div className="d-flex align-items-center justify-content-start  fs-12 fw-600 cardTextGrey">
                                <span className="card-label-width"> FROM : </span>
                                <span className="ms-2 fs-14 fw-400 textcolor two-line-ellipsis">{sanitizeInput(stop.start_address ?? "")}</span>
                            </div>
                            <div className="d-flex align-items-center justify-content-start fs-12 fw-600 cardTextGrey mt-1">
                                <span className="card-label-width"> TO : </span>
                                <span className="ms-2 fs-14 fw-400 textcolor two-line-ellipsis">{sanitizeInput(stop.location ?? "")}</span>
                            </div>
                        </div>
                    </div>

                    <div className="col-2  d-flex flex-row  align-items-end justify-content-end gap-2 ps-3">
                        <div onClick={(e) => e.stopPropagation()}>
                            <Dropdown>
                                <Dropdown.Toggle
                                    bsPrefix="custom-toggle"
                                    variant="light"
                                    id="dropdown-sort"
                                    className="trip-grid-status-badge-toggle d-flex align-items-center justify-content-between bg-ECF2FF rounded-3"
                                >
                                    <span className="d-flex align-items-center px-1 gap-2">
                                        <span className=" fs-11 fw-700 text-3469E7">{sanitizeInput(stop.trip_status ?? "-")}</span>
                                    </span>
                                </Dropdown.Toggle>
                            </Dropdown>
                        </div>
                        <div onClick={(e) => e.stopPropagation()}>
                            {(((checkPermission("edit_permission") || checkPermission("delete_permission")) && stop.trip_status === "Created") || stop.trip_status !== "Trip end") && (
                                <Dropdown>
                                    <Dropdown.Toggle
                                        bsPrefix="custom-toggle"
                                        variant="light"
                                        id="dropdown-sort"
                                        className="trip-grid-more-dropdown-toggle d-flex align-items-center justify-content-between rounded-5"
                                    >
                                        <span className="d-flex align-items-center px-1 gap-2">
                                            <img src={moreIcon} alt="more" />
                                        </span>
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu className="trip-grid-more-dropdown-menu">
                                        {stop.trip_status !== "Trip end" && (
                                            <Dropdown.Item
                                                className="fs-14 fw-500 textcolor"
                                                onClick={() => {
                                                    getMilestoneDetails(stop.id);
                                                }}
                                            >
                                                Update Milestone
                                            </Dropdown.Item>
                                        )}

                                        {stop.trip_status !== "Trip end" && (
                                            <Dropdown.Item
                                                className="fs-14 fw-500 textcolor"
                                                onClick={() => {
                                                    setAllocationTripId(stop.id);
                                                    setShowDriverAllocationModal(true);
                                                }}
                                            >
                                                Allocate Driver
                                            </Dropdown.Item>
                                        )}
                                        {checkPermission("edit_permission") && stop.trip_status === "Created" && (
                                            <Dropdown.Item
                                                className="fs-14 fw-500 textcolor"
                                                onClick={() => {
                                                    navigate("/trips/create", {
                                                        state: { id: stop.id },
                                                    });
                                                }}
                                            >
                                                Edit
                                            </Dropdown.Item>
                                        )}
                                        {checkPermission("delete_permission") && stop.trip_status === "Created" && (
                                            <Dropdown.Item
                                                className="fs-14 fw-500 textcolor"
                                                onClick={() => {
                                                    setDeleteId(stop.id);
                                                }}
                                            >
                                                Delete
                                            </Dropdown.Item>
                                        )}
                                    </Dropdown.Menu>
                                </Dropdown>
                            )}
                        </div>
                    </div>
                </div>
            ))}
        </>
    );
};

export default TripsGridView;
